module.exports = __webpack_public_path__ + "img/Trophy.2f09fe65.jpg";